module.exports = __webpack_public_path__ + "img/img(2).1272a91d.png";